import { render, staticRenderFns } from "./GdprProgressElement.vue?vue&type=template&id=df23d69c&scoped=true&"
import script from "./GdprProgressElement.vue?vue&type=script&lang=js&"
export * from "./GdprProgressElement.vue?vue&type=script&lang=js&"
import style0 from "./GdprProgressElement.vue?vue&type=style&index=0&id=df23d69c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df23d69c",
  null
  
)

export default component.exports